import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

// Son iki veri noktası arasındaki değişimi (yüzde ya da mutlak) küçük rozet olarak gösterir.
export function TrendBadge({ data, dataKey, label, goodWhenUp = true }) {
  const pts = (data || []).map((d) => (d ? d[dataKey] : null)).filter((v) => v != null);
  if (pts.length < 2) return null;
  const last = pts[pts.length - 1];
  const prev = pts[pts.length - 2];
  const diff = last - prev;
  const flat = diff === 0;
  const up = diff > 0;
  const good = flat ? null : up === goodWhenUp;
  const cls = flat
    ? "text-muted-foreground bg-muted"
    : good
      ? "text-emerald-600 bg-emerald-500/10"
      : "text-red-600 bg-red-500/10";
  const Icon = flat ? Minus : up ? TrendingUp : TrendingDown;
  const val = prev !== 0
    ? `${diff > 0 ? "+" : ""}${Math.round((diff / Math.abs(prev)) * 100)}%`
    : `${diff > 0 ? "+" : ""}${diff}`;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] font-semibold px-1.5 py-0.5 rounded ${cls}`}
      data-testid={`trend-${dataKey}`}
      title="Son güne göre değişim"
    >
      {label && <span className="opacity-70 font-medium">{label}</span>}
      <Icon className="h-3 w-3" />
      {val}
    </span>
  );
}
